'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactAddonsUpdate = require('react-addons-update');

var _reactAddonsUpdate2 = _interopRequireDefault(_reactAddonsUpdate);

var _reactBootstrap = require('react-bootstrap');

var _reactRedux = require('react-redux');

var _events = require('redux/modules/events');

var eventActions = _interopRequireWildcard(_events);

var _can = require('helpers/can');

var _can2 = _interopRequireDefault(_can);

var _lodash = require('lodash.find');

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = require('lodash.isempty');

var _lodash4 = _interopRequireDefault(_lodash3);

var _translations2 = require('helpers/translations');

var _components = require('components');

var _config = require('../../config.js');

var _config2 = _interopRequireDefault(_config);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventForm = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    calendars: state.auth.user.calendars,
    event: state.events.event,
    image: state.events.image,
    loaded: state.events.loaded,
    loading: state.events.loading,
    saving: state.events.saving,
    saveError: state.events.saveError,
    user: state.auth.user
  };
}, (0, _extends3.default)({}, eventActions), null, { withRef: true }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(EventForm, _Component);

  function EventForm() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, EventForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EventForm.__proto__ || (0, _getPrototypeOf2.default)(EventForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      autofocus: false,
      data: _this.props.event,
      errors: {},
      eventHasChanged: false,
      happiness: 0,
      popoverContainer: null,
      locale: 'fr',
      mapsCenter: null,
      mapsMarker: [],
      showCloseModalPopover: false
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(EventForm, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (!this.props.eventId) {
        this.setState({
          autofocus: true
        });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var _props = this.props,
          eventId = _props.eventId,
          calendar = _props.calendar,
          getEvent = _props.getEvent,
          newEvent = _props.newEvent;


      var calendarId = calendar ? calendar.id : null;

      if (eventId) {
        getEvent(eventId, calendarId).then(function (res) {
          var event = res.result;

          if (event.dates && event.dates.length > 0) {
            _this2.reloadMap(event.dates[0].venue);
          }
          var status = event.status;
          // FIXME This whole design is problematic because we mix context in requests
          // That is : the status depends on the selected calendar, it is not an
          // event concern but a calendar concern
          if (status === 'partially_published') {
            status = 'pending';
          }
          _this2.setState({
            status: status
          }, _this2.computeHappiness());

          if (!event.defaultVenue && event.dates[0].venue) {
            _this2.handleChangeField('defaultVenue', event.dates[0].venue);
          }

          if (!event.defaultRoom && event.dates[0].room) {
            _this2.handleChangeField('defaultRoom', event.dates[0].room);
          }
        });
      } else {
        newEvent(calendar);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.event !== this.props.event) {
        this.setState({ data: nextProps.event });
      }

      if (nextProps.image !== this.props.image) {
        this.setState({
          data: (0, _reactAddonsUpdate2.default)(this.state.data, { $merge: { image: nextProps.image } })
        });
      }

      if (nextProps.saveError !== this.props.saveError) {
        this.setState({ errors: nextProps.saveError[nextProps.event.id || 'new'].errors || {} });
      }

      this.computeHappiness();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.removeErrors();
    }
  }, {
    key: 'setMarkers',
    value: function setMarkers(mapsCenter) {
      this.setState({
        mapsCenter: mapsCenter,
        mapsMarkers: [{
          position: mapsCenter,
          defaultAnimation: null,
          key: Date.now()
        }]
      });
    }
  }, {
    key: 'reloadMap',
    value: function reloadMap(venue) {
      var _this3 = this;

      var GoogleMapsAPI = window.google.maps;
      if (venue) {
        if (venue.latitude && venue.longitude) {
          var mapsCenter = new GoogleMapsAPI.LatLng(venue.latitude, venue.longitude);
          this.setMarkers(mapsCenter);
        } else {
          var geocodeAddress = [venue.address, venue.city, venue.country, venue.zip].join(' ');

          var geocoder = new GoogleMapsAPI.Geocoder();
          geocoder.geocode({ address: geocodeAddress }, function (results, status) {
            if (status === GoogleMapsAPI.GeocoderStatus.OK) {
              var _mapsCenter = results[0].geometry.location;
              _this3.setMarkers(_mapsCenter);
            }
          });
        }
      }
    }
  }, {
    key: 'validateTitle',
    value: function validateTitle(ev) {
      if (ev.keyCode === 13 || ev.keyCode === 9) {
        document.getElementById('event-title-box').blur();
      }
    }
  }, {
    key: 'handleChangeTitle',
    value: function handleChangeTitle(ev) {
      return this.handleChangeField('title', ev.target.value);
    }
  }, {
    key: 'handleChangeCalendars',
    value: function handleChangeCalendars(calendars) {
      return this.handleChangeField('calendars', calendars);
    }
  }, {
    key: 'handleChangeDates',
    value: function handleChangeDates(startDate, endDate, recurring, dates) {
      return this.handleChangeFields({
        start_date: startDate,
        end_date: endDate,
        recurring: recurring,
        dates: dates
      });
    }
  }, {
    key: 'handleChangeAudiences',
    value: function handleChangeAudiences(selectedAudiences) {
      return this.handleChangeField('audiences', selectedAudiences);
    }
  }, {
    key: 'handleChangeOrganization',
    value: function handleChangeOrganization(selectedOrganization) {
      return this.handleChangeField('organization', selectedOrganization);
    }
  }, {
    key: 'handleChangeContactInformation',
    value: function handleChangeContactInformation(contact) {
      return this.handleChangeFields({
        contact_name: contact.name,
        contact_email: contact.email,
        contact_phone: contact.phone,
        contact_url: contact.url
      });
    }
  }, {
    key: 'handleChangeDescription',
    value: function handleChangeDescription(description) {
      return this.handleChangeField('description', description);
    }
  }, {
    key: 'handleChangeGroups',
    value: function handleChangeGroups(groups) {
      return this.handleChangeField('groups', groups);
    }
  }, {
    key: 'buildHandleChangeTerms',
    value: function buildHandleChangeTerms(taxonomyId) {
      var _this4 = this;

      return function (newTerms) {
        var data = _this4.state.data;


        var terms = data.terms.filter(function (term) {
          return term.taxonomy_id !== taxonomyId;
        });
        terms.push.apply(terms, (0, _toConsumableArray3.default)(newTerms));

        return _this4.handleChangeField('terms', terms);
      };
    }
  }, {
    key: 'handleRemoveImage',
    value: function handleRemoveImage(index) {
      var errors = this.state.errors;
      var data = this.state.data;


      data = (0, _reactAddonsUpdate2.default)(data, {
        images: {
          $splice: [[index, 1]]
        }
      });

      this.updateFormState(data, errors);
    }
  }, {
    key: 'handleAddImage',
    value: function handleAddImage(image, callback) {
      var _this5 = this;

      var _props2 = this.props,
          saveImage = _props2.saveImage,
          loading = _props2.loading;
      var errors = this.state.errors;
      var data = this.state.data;


      if (!loading) {
        saveImage(image).then(function (res) {
          if (res && res.type === eventActions.SAVE_IMAGE_SUCCESS) {
            data = (0, _reactAddonsUpdate2.default)(data, {
              images: {
                $splice: [[data.images.length, 0, (0, _extends3.default)({}, res.result, {
                  description: '',
                  title: '',
                  credits: '',
                  sizes: {
                    original: '' + _config2.default.cdnRoot + res.result.url + '/' + res.result.filename
                  }
                })]]
              }
            });

            _this5.updateFormState(data, errors, callback);
          }
        });
      }
    }
  }, {
    key: 'handleChangeFacebookLink',
    value: function handleChangeFacebookLink(facebookUrl) {
      return this.handleChangeField('facebook_url', facebookUrl);
    }
  }, {
    key: 'handleChangePrice',
    value: function handleChangePrice(type, prices, currency, notes, ticketUrl) {
      return this.handleChangeFields({
        price_type: type,
        price_currency: currency,
        prices: prices,
        price_notes: notes,
        ticket_url: ticketUrl
      });
    }
  }, {
    key: 'handleChangeStatus',
    value: function handleChangeStatus(ev) {
      return this.handleChangeField('status', ev.target.value);
    }
  }, {
    key: 'handleChangeTags',
    value: function handleChangeTags(tags) {
      var _this6 = this;

      var data = this.state.data;

      var categoryTags = [];
      data.tags.forEach(function (tag) {
        if (_this6.isTagCategory(tag.id)) {
          categoryTags.push(tag);
        }
      });

      return this.handleChangeField('tags', [].concat(categoryTags, (0, _toConsumableArray3.default)(tags)));
    }
  }, {
    key: 'handleChangeTypes',
    value: function handleChangeTypes(types) {
      return this.handleChangeField('types', types);
    }
  }, {
    key: 'handleChangeCategories',
    value: function handleChangeCategories(tags, types) {
      var _this7 = this;

      var data = this.state.data;

      var nonCategoryTags = [];
      data.tags.forEach(function (tag) {
        if (!_this7.isTagCategory(tag.id)) {
          nonCategoryTags.push(tag);
        }
      });

      var nonCategoryTypes = [];
      data.types.forEach(function (type) {
        if (!_this7.isTypeCategory(type.id)) {
          nonCategoryTypes.push(type);
        }
      });

      this.handleChangeFields({
        'types': [].concat(nonCategoryTypes, (0, _toConsumableArray3.default)(types)),
        'tags': [].concat(nonCategoryTags, (0, _toConsumableArray3.default)(tags))
      });
    }
  }, {
    key: 'handleChangeVideoURL',
    value: function handleChangeVideoURL(url, oEmbed) {
      return this.handleChangeFields({
        video: oEmbed,
        video_url: url
      });
    }
  }, {
    key: 'handleRemoveVideo',
    value: function handleRemoveVideo() {
      return this.handleChangeFields({
        video: null,
        video_url: null
      });
    }
  }, {
    key: 'handleChangeVenue',
    value: function handleChangeVenue(dates, defaults) {
      var _this8 = this;

      this.handleChangeFields({
        dates: dates
      }, function () {
        var venue = dates.length > 0 ? dates[0].venue || null : null;
        _this8.reloadMap(venue);
      });

      if (defaults && defaults.venue) {
        this.handleChangeField('defaultVenue', defaults.venue);
      }

      if (defaults && defaults.room) {
        this.handleChangeField('defaultRoom', defaults.room);
      }
    }
  }, {
    key: 'handleDeleteImage',
    value: function handleDeleteImage(imageId) {
      var loading = this.props.loading;
      var errors = this.state.errors;
      var data = this.state.data;


      if (!loading) {
        var newImages = data.images.filter(function (item) {
          return item.id !== imageId;
        });
        var image = newImages.length > 0 ? (0, _assign2.default)({}, newImages[0]) : null;
        data = (0, _reactAddonsUpdate2.default)(data, {
          $merge: {
            image: image,
            images: newImages
          }
        });

        this.updateFormState(data, errors);
      }
    }
  }, {
    key: 'handleChangeImage',
    value: function handleChangeImage(image) {
      var _this9 = this;

      var saveImage = this.props.saveImage;
      var errors = this.state.errors;
      var data = this.state.data;


      saveImage(image).then(function (res) {
        if (res && res.type === eventActions.SAVE_IMAGE_SUCCESS) {
          data = (0, _reactAddonsUpdate2.default)(data, {
            $merge: {
              image: res.result
            },
            images: { $splice: [[0, data.images.length, res.result]] }
          });

          _this9.updateFormState(data, errors);
        }
      });
    }
  }, {
    key: 'handleChangeImageKey',
    value: function handleChangeImageKey(key) {
      var _this10 = this;

      return function (index, value) {
        var data = _this10.state.data;


        data = (0, _reactAddonsUpdate2.default)(data, {
          images: (0, _defineProperty3.default)({}, index, {
            $merge: (0, _defineProperty3.default)({}, key, value)
          })
        });

        _this10.updateFormState(data);
      };
    }
  }, {
    key: 'handleChangeImagePosition',
    value: function handleChangeImagePosition(result) {
      var data = this.state.data;


      var source = (0, _assign2.default)({}, data.images[result.source.index]);

      data = (0, _reactAddonsUpdate2.default)(data, {
        images: {
          $splice: [[result.source.index, 1], [result.destination.index, 0, source]]
        }
      });

      data.images.map(function (item, index) {
        data = (0, _reactAddonsUpdate2.default)(data, {
          images: (0, _defineProperty3.default)({}, index, {
            $merge: {
              position: index + 1
            }
          })
        });
      });

      this.updateFormState(data);
    }
  }, {
    key: 'handleChangeFields',
    value: function handleChangeFields(changes, callback) {
      var _state = this.state,
          data = _state.data,
          errors = _state.errors;
      var locale = this.state.locale;


      if (data.translations) {
        var translationIndex = data.translations.findIndex(function (t) {
          return t.lang === locale;
        });

        // Don't set unsupported keys in the translation data
        var translationChanges = (0, _keys2.default)(changes).reduce(function (acc, key) {
          if (key === 'id') {
            return acc;
          }

          if (data.translations[translationIndex][key] !== undefined) {
            acc[key] = changes[key];
          }

          return acc;
        }, {});

        data = (0, _reactAddonsUpdate2.default)(data, {
          translations: (0, _defineProperty3.default)({}, translationIndex, {
            $merge: translationChanges
          })
        });
      }

      data = (0, _reactAddonsUpdate2.default)(data, {
        $merge: changes
      });

      errors = (0, _reactAddonsUpdate2.default)(errors, {
        $merge: (0, _keys2.default)(changes).reduce(function (acc, f) {
          acc[f] = [];
          return acc;
        }, {})
      });

      this.updateFormState(data, errors, callback);
    }
  }, {
    key: 'handleChangeField',
    value: function handleChangeField(field, value, callback) {
      return this.handleChangeFields((0, _defineProperty3.default)({}, field, value), callback);
    }
  }, {
    key: 'updateFormState',
    value: function updateFormState(data, errors, callback) {
      this.setState({
        data: data,
        errors: errors,
        eventHasChanged: true
      }, this.computeHappiness(callback));
    }
  }, {
    key: 'computeHappiness',
    value: function computeHappiness(callback) {
      var _this11 = this;

      return function () {
        var requiredFields = ['title', 'description', 'venue', 'types', 'dates'];

        var data = _this11.state.data;


        var happinessRequired = 0;

        requiredFields.forEach(function (field) {
          if (field === 'types') {
            happinessRequired += +(!(0, _lodash4.default)(data.types) | !(0, _lodash4.default)(data.tags));
          } else {
            happinessRequired += +!(0, _lodash4.default)(data[field]);
          }
        });

        _this11.setState({
          happiness: happinessRequired / requiredFields.length * 100
        }, callback);
      };
    }
  }, {
    key: 'handleSave',
    value: function handleSave() {
      var _this12 = this;

      var save = this.props.save;
      var data = this.state.data;


      save(data).then(function (res) {
        if (res && res.type === eventActions.SAVE_SUCCESS) {
          _this12.handleCloseModal();
        }
      });
    }
  }, {
    key: 'showCloseModalPopover',
    value: function showCloseModalPopover() {
      this.setState({
        showCloseModalPopover: true
      });
    }
  }, {
    key: 'handleCloseModal',
    value: function handleCloseModal() {
      this.props.closeModal();
    }
  }, {
    key: 'isTagCategory',
    value: function isTagCategory(id) {
      var calendar = this.props.calendar;

      if (calendar && calendar.options.hasOwnProperty('categoryIds') && calendar.options.categoryIds.hasOwnProperty('tags')) {
        return calendar.options.categoryIds.tags.indexOf(parseInt(id, 10)) !== -1;
      }
      return false;
    }
  }, {
    key: 'isTypeCategory',
    value: function isTypeCategory(id) {
      var calendar = this.props.calendar;

      if (calendar && calendar.options.hasOwnProperty('categoryIds') && calendar.options.categoryIds.hasOwnProperty('types')) {
        return calendar.options.categoryIds.types.indexOf(parseInt(id, 10)) !== -1;
      }
      return false;
    }
  }, {
    key: 'switchTranslation',
    value: function switchTranslation(newLocale) {
      var data = this.state.data;


      var currentTranslation = data.translations.find(function (trl) {
        return trl.lang === newLocale;
      }) || {};

      delete currentTranslation.id;

      this.setState({
        locale: newLocale,
        data: (0, _reactAddonsUpdate2.default)(data, { $merge: currentTranslation })
      }, this.computeHappiness());
    }
  }, {
    key: 'switchLocale',
    value: function switchLocale(newLocale) {
      var _this13 = this;

      var data = this.state.data;


      if (!data.translations.find(function (trl) {
        return trl.lang === newLocale;
      })) {
        return this.setState({
          data: (0, _reactAddonsUpdate2.default)(data, {
            translations: { $push: [(0, _translations2.newTranslation)(newLocale)] }
          })
        }, function () {
          _this13.switchTranslation(newLocale);
        });
      }

      this.switchTranslation(newLocale);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this14 = this;

      var _props3 = this.props,
          calendar = _props3.calendar,
          calendars = _props3.calendars,
          eventId = _props3.eventId,
          loaded = _props3.loaded,
          loading = _props3.loading,
          polyglot = _props3.polyglot,
          requireCloseModal = _props3.requireCloseModal,
          saveError = _props3.saveError,
          saving = _props3.saving;
      var _state2 = this.state,
          event = _state2.data,
          errors = _state2.errors,
          happiness = _state2.happiness,
          locale = _state2.locale,
          mapsCenter = _state2.mapsCenter,
          mapsMarkers = _state2.mapsMarkers;


      var priceBoxErrors = {
        ticket_url: errors.ticket_url || []
      };

      var contactInformationErrors = {
        contact_url: errors.contact_url || []
      };

      var popoverContainer = this;
      var selectedCalendars = event.calendars.map(function (cal) {
        var selected = (0, _lodash2.default)(calendars, { id: cal.id });
        return selected;
      }).filter(function (cal) {
        return !!cal;
      });

      var locales = (calendar || event).translations.map(function (t) {
        return t.lang;
      });

      var calendarOptions = (0, _assign2.default)({
        audiences: true,
        categories: false,
        groups: true,
        tags: true,
        organization: true,
        contactInformation: true,
        media: {
          singleMedia: true,
          multipleMedia: false
        },
        categoryIds: {
          tags: [],
          types: []
        }
      }, calendar ? calendar.options : {});

      var tags = [];
      var types = [];
      var categories = {
        tags: [],
        types: []
      };

      if (calendarOptions.categories) {
        event.tags.forEach(function (tag) {
          if (_this14.isTagCategory(tag.id)) {
            categories.tags.push(tag);
          } else {
            tags.push(tag);
          }
        });

        event.types.forEach(function (type) {
          if (_this14.isTypeCategory(type.id)) {
            categories.types.push(type);
          } else {
            types.push(type);
          }
        });
      } else {
        tags = event.tags;
        types = event.types;
      }

      var hasTypesOrTags = !event.types.length && !event.tags.length;
      var hasErrors = saveError[eventId || 'new'] && saveError[eventId || 'new'].status_code;
      var errorMessage = hasErrors && polyglot.t('errors.' + saveError[eventId || 'new'].status_code);

      return _react2.default.createElement(
        _components.Loader,
        { loaded: loaded },
        _react2.default.createElement(
          'div',
          { className: 'modal-body' },
          _react2.default.createElement(
            'div',
            { className: 'event-form' },
            _react2.default.createElement(
              _reactBootstrap.OverlayTrigger,
              {
                trigger: 'click',
                placement: 'bottom',
                rootClose: true,
                overlay: _react2.default.createElement(
                  _reactBootstrap.Popover,
                  { id: 'closeModalPopover', className: 'closeform-box-popover' },
                  _react2.default.createElement(_components.CloseModalPopover, { close: this.handleCloseModal.bind(this), save: this.handleSave.bind(this), saving: saving, scope: 'events', polyglot: polyglot })
                )
              },
              _react2.default.createElement('button', {
                type: 'button',
                onClick: requireCloseModal,
                className: 'close-modal-button icon-cg-close'
              })
            ),
            _react2.default.createElement(
              _reactBootstrap.Row,
              null,
              _react2.default.createElement(_components.TitleBox, {
                title: event.title,
                onChange: this.handleChangeTitle.bind(this),
                onKeyUp: this.validateTitle.bind(this),
                autoFocus: this.state.autofocus,
                errors: errors.title || [],
                polyglot: polyglot
              })
            ),
            _react2.default.createElement(
              _reactBootstrap.Row,
              { className: 'types-locales-row' },
              calendarOptions.categories ? _react2.default.createElement(
                _reactBootstrap.Col,
                { md: 4, mdOffset: 4 },
                _react2.default.createElement(_components.CategoriesBox, {
                  categories: calendar.categories,
                  selectedCategories: categories,
                  tags: tags,
                  types: types,
                  onChange: this.handleChangeCategories.bind(this),
                  polyglot: polyglot
                })
              ) : _react2.default.createElement(_components.TypeBox, {
                popoverContainer: popoverContainer,
                selectedTypes: types,
                onChange: this.handleChangeTypes.bind(this),
                errors: errors.types || [],
                polyglot: polyglot,
                required: hasTypesOrTags
              }),
              locales.length > 1 && _react2.default.createElement(
                _reactBootstrap.ButtonGroup,
                { className: 'locales-box' },
                _react2.default.createElement(
                  _reactBootstrap.Button,
                  {
                    tabIndex: '-1',
                    onClick: function onClick() {
                      _this14.switchLocale('fr');
                    },
                    bsStyle: locale === 'fr' ? 'primary' : 'default' },
                  'Fran\xE7ais'
                ),
                _react2.default.createElement(
                  _reactBootstrap.Button,
                  {
                    tabIndex: '-1',
                    onClick: function onClick() {
                      _this14.switchLocale('en');
                    },
                    bsStyle: locale === 'en' ? 'primary' : 'default' },
                  'Anglais'
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'event-top-bar row' },
              _react2.default.createElement(
                'div',
                { className: 'col-sm-4' },
                _react2.default.createElement(_components.DatesBox, {
                  popoverContainer: popoverContainer,
                  startDate: event.start_date,
                  endDate: event.end_date,
                  dates: event.dates,
                  recurring: event.recurring,
                  defaultVenue: event.defaultVenue,
                  defaultRoom: event.defaultRoom,
                  onChange: this.handleChangeDates.bind(this),
                  errors: errors.dates || [],
                  polyglot: polyglot
                })
              ),
              _react2.default.createElement(
                'div',
                { ref: 'venueContainer', className: 'col-sm-4' },
                _react2.default.createElement(_components.VenueBox, {
                  allowMultipleVenues: calendarOptions.multipleVenues,
                  regions: calendar ? calendar.regions : [],
                  popoverContainer: popoverContainer,
                  dates: event.dates,
                  defaultVenue: event.defaultVenue,
                  defaultRoom: event.defaultRoom,
                  onChange: this.handleChangeVenue.bind(this),
                  errors: errors.venue || [],
                  polyglot: polyglot
                })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-sm-4' },
                _react2.default.createElement(
                  'div',
                  { className: 'event-map-box' },
                  _react2.default.createElement(_components.SimpleMap, {
                    mapsCenter: mapsCenter,
                    markers: mapsMarkers,
                    onMapClick: function onMapClick() {},
                    onMarkerRightclick: function onMarkerRightclick() {}
                  })
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'col-sm-4' },
                calendar && calendar.options.media && calendar.options.media.multipleMedia && _react2.default.createElement(_components.MediaBox, {
                  handleAddImage: this.handleAddImage.bind(this),
                  handleChangeImageCredits: this.handleChangeImageKey.call(this, 'credits'),
                  handleChangeImagePosition: this.handleChangeImagePosition.bind(this),
                  handleRemoveImage: this.handleRemoveImage.bind(this),
                  loading: loading,
                  images: event.images,
                  title: 'Images',
                  polyglot: polyglot
                }),
                (!calendar || !calendar.options.media || calendar.options.media.singleMedia) && _react2.default.createElement(_components.ImageBox, {
                  popoverContainer: popoverContainer,
                  handleChangeImage: this.handleChangeImage.bind(this),
                  handleDeleteImage: this.handleDeleteImage.bind(this),
                  loading: loading,
                  image: event.image,
                  polyglot: polyglot
                }),
                (!calendar || calendarOptions.organization) && _react2.default.createElement(_components.OrganizationBox, {
                  popoverContainer: popoverContainer,
                  organization: event.organization,
                  onChange: this.handleChangeOrganization.bind(this),
                  polyglot: polyglot
                }),
                _react2.default.createElement(_components.FacebookBox, {
                  errors: errors.facebook_url || [],
                  popoverContainer: popoverContainer,
                  facebookUrl: event.facebook_url,
                  onChange: this.handleChangeFacebookLink.bind(this),
                  polyglot: polyglot
                }),
                _react2.default.createElement(_components.PriceBox, {
                  popoverContainer: popoverContainer,
                  prices: event.prices,
                  notes: event.price_notes,
                  ticketUrl: event.ticket_url,
                  type: event.price_type,
                  currency: event.price_currency,
                  onChange: this.handleChangePrice.bind(this),
                  polyglot: polyglot,
                  errors: priceBoxErrors
                }),
                (!calendar || calendarOptions.contactInformation) && _react2.default.createElement(_components.ContactInformation, {
                  popoverContainer: popoverContainer,
                  errors: contactInformationErrors,
                  name: event.contact_name,
                  email: event.contact_email,
                  phone: event.contact_phone,
                  url: event.contact_url,
                  onChange: this.handleChangeContactInformation.bind(this),
                  organization: event.organization,
                  polyglot: polyglot
                }),
                (!calendar || calendar.options.audiences) && _react2.default.createElement(_components.AudienceBox, { popoverContainer: popoverContainer,
                  availableAudiences: calendar && calendar.audiences.length ? calendar.audiences : undefined,
                  selectedAudiences: event.audiences,
                  onChange: this.handleChangeAudiences.bind(this),
                  polyglot: polyglot
                })
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-sm-8' },
                _react2.default.createElement(_components.DescriptionBox, {
                  description: event.description,
                  onChange: this.handleChangeDescription.bind(this),
                  errors: errors.description || [],
                  polyglot: polyglot
                }),
                _react2.default.createElement(_components.VideoBox, {
                  popoverContainer: popoverContainer,
                  video_url: event.video_url,
                  onRemoveVideo: this.handleRemoveVideo.bind(this),
                  onChange: this.handleChangeVideoURL.bind(this),
                  polyglot: polyglot
                }),
                (!calendar || calendarOptions.tags) && _react2.default.createElement(_components.TagBox, {
                  popoverContainer: popoverContainer,
                  onChange: this.handleChangeTags.bind(this),
                  selectedTags: tags,
                  errors: errors.tags || [],
                  polyglot: polyglot,
                  required: hasTypesOrTags
                }),
                (!calendar || calendarOptions.groups) && _react2.default.createElement(_components.GroupsBox, { popoverContainer: popoverContainer,
                  onChange: this.handleChangeGroups.bind(this),
                  selectedOrganizations: event.groups,
                  errors: errors.groups || [],
                  polyglot: polyglot,
                  customLabel: calendar && calendar.id === 37 && 'Présenté par'
                }),
                calendar && calendar.taxonomies.map(function (tax) {
                  return _react2.default.createElement(_components.TermsBox, {
                    key: tax.id,
                    taxonomy: tax,
                    popoverContainer: popoverContainer,
                    onChange: _this14.buildHandleChangeTerms.call(_this14, tax.id),
                    selectedTerms: event.terms.filter(function (term) {
                      return term.taxonomy_id === tax.id;
                    }),
                    errors: errors.terms || [],
                    polyglot: polyglot
                  });
                })
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'modal-footer ' + (!!hasErrors && 'with-errors') },
          hasErrors && _react2.default.createElement(
            'div',
            { className: 'errors' },
            errorMessage
          ),
          _react2.default.createElement(_components.HappinessIndicator, {
            happiness: happiness,
            className: 'pull-left col-xs-7 col-sm-4 col-lg-3',
            polyglot: polyglot,
            container: popoverContainer
          }),
          calendars.length > 1 && _react2.default.createElement(
            'div',
            { className: 'event-calendar-box pull-left' },
            _react2.default.createElement(_components.CalendarBox, {
              container: popoverContainer,
              onChange: this.handleChangeCalendars.bind(this),
              selectedCalendars: event.calendars,
              polyglot: polyglot
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'pull-right' },
            event.source && _react2.default.createElement(
              'span',
              { className: 'source' },
              polyglot.t('events.form.importedFrom'),
              ' ',
              event.source
            ),
            _react2.default.createElement(
              'span',
              { className: 'status-label' },
              polyglot.t('events.form.status.title')
            ),
            _react2.default.createElement(
              'label',
              { className: 'select-wrapper' },
              _react2.default.createElement(
                'select',
                { name: 'status', className: 'form-control', value: event.status, onChange: this.handleChangeStatus.bind(this) },
                _react2.default.createElement(
                  'option',
                  { value: 'draft' },
                  polyglot.t('events.form.status.draft')
                ),
                event.status === 'pending' && _react2.default.createElement(
                  'option',
                  { value: 'pending' },
                  polyglot.t('events.form.status.pending')
                ),
                (event.status !== 'pending' || (0, _can2.default)('contributor', selectedCalendars) || calendar && (0, _can2.default)('contributor', calendar)) && _react2.default.createElement(
                  'option',
                  { value: 'published' },
                  polyglot.t('events.form.status.published')
                )
              )
            ),
            _react2.default.createElement(
              'button',
              {
                type: 'button',
                className: 'btn btn-primary',
                onClick: !saving ? this.handleSave.bind(this) : null,
                disabled: saving
              },
              saving ? _react2.default.createElement('i', { className: 'glyphicon glyphicon-refresh cg-spinner' }) : '',
              ' ',
              polyglot.t('events.form.save')
            )
          )
        )
      );
    }
  }]);
  return EventForm;
}(_react.Component), _class2.propTypes = {
  calendars: _propTypes2.default.array,
  calendar: _propTypes2.default.object,
  closeModal: _propTypes2.default.func,
  eventId: _propTypes2.default.number,
  event: _propTypes2.default.object,
  image: _propTypes2.default.object,
  loading: _propTypes2.default.bool,
  loaded: _propTypes2.default.bool,
  getEvent: _propTypes2.default.func,
  newEvent: _propTypes2.default.func,
  polyglot: _propTypes2.default.object.isRequired,
  removeErrors: _propTypes2.default.func,
  requireCloseModal: _propTypes2.default.func,
  save: _propTypes2.default.func.isRequired,
  saving: _propTypes2.default.bool,
  saveError: _propTypes2.default.object,
  saveImage: _propTypes2.default.func,
  user: _propTypes2.default.object.isRequired
}, _temp2)) || _class);
exports.default = EventForm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Event/EventForm.js
// module id = 2192
// module chunks = 0